import {useI18n} from '@udemy/i18n';

export const CapitalizeFirstLetter = (word: string) => {
    const {gettext} = useI18n();

    word = word.toLowerCase().replace(/_/g, ' ');
    let finalStatus: string = word.charAt(0).toUpperCase() + word.slice(1);

    //TODO fix localization for ready to pay status and remove this
    if (finalStatus == 'Ready to pay') finalStatus = 'Ready To Pay';

    // eslint-disable-next-line @udemy/no-variable-string
    return gettext(finalStatus);
};
